// Azzurro vocabulary expansion — DESCRIBING theme (net-new cards).
//
// Extends the `describing` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `spanish`, so every value is unique.
//   [ italian, english, emoji, part_of_speech, gender, example_it, example_en ]

export const VOCAB_DESCRIBING = [
  {
    theme: "describing", tier: "A1", rows: [
      ["alto", "tall", "📏", "adjective", "", "Mio fratello è molto alto.", "My brother is very tall."],
      ["basso", "short (height)", "📐", "adjective", "", "Il tavolo è troppo basso.", "The table is too low."],
      ["grasso", "fat", "🐷", "adjective", "", "Il gatto è un po' grasso.", "The cat is a bit fat."],
      ["magro", "thin / slim", "🌿", "adjective", "", "È alta e magra.", "She's tall and slim."],
      ["giovane", "young", "🧒", "adjective", "", "Il professore è molto giovane.", "The teacher is very young."],
      ["carino", "good-looking", "😎", "adjective", "", "Tua sorella è molto carina.", "Your sister is very good-looking."],
      ["rotondo", "round", "⚪", "adjective", "", "Il tavolo è rotondo.", "The table is round."],
      ["quadrato", "square", "🟦", "adjective", "", "La scatola è quadrata.", "The box is square."],
      ["pieno", "full", "🪣", "adjective", "", "Il bicchiere è pieno.", "The glass is full."],
      ["vuoto", "empty", "🫙", "adjective", "", "La bottiglia è vuota.", "The bottle is empty."],
    ],
  },
  {
    theme: "describing", tier: "A2", rows: [
      ["ampio", "spacious / roomy", "🏠", "adjective", "", "Il salotto è molto ampio.", "The living room is very spacious."],
      ["rumoroso", "noisy", "🔊", "adjective", "", "Il bar è troppo rumoroso.", "The bar is too noisy."],
      ["silenzioso", "quiet / silent", "🤫", "adjective", "", "Il motore è molto silenzioso.", "The engine is very quiet."],
      ["comodo", "comfortable", "🛋️", "adjective", "", "Il divano è molto comodo.", "The sofa is very comfortable."],
      ["scomodo", "uncomfortable", "🪑", "adjective", "", "La sedia è scomoda.", "The chair is uncomfortable."],
      ["utile", "useful", "🛠️", "adjective", "", "Questa applicazione è molto utile.", "This app is very useful."],
      ["inutile", "useless", "🚯", "adjective", "", "Il vecchio telecomando è inutile.", "The old remote is useless."],
      ["moderno", "modern", "🏢", "adjective", "", "L'edificio è molto moderno.", "The building is very modern."],
      ["antico", "old / antique", "🏛️", "adjective", "", "Hanno un orologio antico.", "They have an antique clock."],
      ["duro", "hard / tough", "🪵", "adjective", "", "Il pane è duro.", "The bread is hard."],
    ],
  },
  {
    theme: "describing", tier: "B1", rows: [
      ["meticoloso", "meticulous / thorough", "🔍", "adjective", "", "Ha fatto un'analisi meticolosa.", "He did a thorough analysis."],
      ["fragile", "flimsy / frail", "🍂", "adjective", "", "La struttura è fragile.", "The structure is flimsy."],
      ["resistente", "tough / durable", "🛡️", "adjective", "", "Il tessuto è molto resistente.", "The fabric is very durable."],
      ["voluminoso", "bulky", "📦", "adjective", "", "Il pacco è voluminoso.", "The package is bulky."],
      ["minuscolo", "tiny", "🐜", "adjective", "", "Ha trovato un errore minuscolo.", "She found a tiny error."],
      ["vistoso", "eye-catching / showy", "🎨", "adjective", "", "Indossa un vestito molto vistoso.", "She's wearing a very eye-catching dress."],
      ["macchinoso", "cumbersome / awkward", "🧶", "adjective", "", "La procedura è macchinosa.", "The procedure is cumbersome."],
      ["versatile", "versatile", "🔧", "adjective", "", "È uno strumento versatile.", "It's a versatile tool."],
      ["conciso", "concise / terse", "✂️", "adjective", "", "Ha mandato un messaggio conciso.", "He sent a terse message."],
      ["nitido", "crisp / sharp (clear)", "🔭", "adjective", "", "L'immagine è nitida.", "The image looks crisp."],
    ],
  },
];
